import React from "react";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-navy text-cream/85 pt-20 pb-10 relative" data-testid="site-footer">
      <div className="px-6 md:px-12 lg:px-20 max-w-7xl mx-auto">
        <div className="grid md:grid-cols-12 gap-10 pb-14 border-b border-cream/10">
          <div className="md:col-span-5">
            <div className="mb-5 inline-block bg-cream/95 px-5 py-3 rounded-sm">
              <img
                src="/brand/logo.png"
                alt="DSO Books Solutions Inc."
                className="h-14 w-auto"
                draggable="false"
              />
            </div>
            <p className="text-cream/65 max-w-md leading-relaxed text-sm mt-2">
              CRA-compliant virtual bookkeeping for Canadian contractors, trades, and
              service businesses. Premium pricing. Premium standards.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs uppercase tracking-[0.22em] text-cream/55 mb-4">Explore</div>
            <ul className="space-y-2.5 text-sm">
              {[
                { id: "services", target: "services", label: "Services" },
                { id: "pricing", target: "contact", label: "Pricing" },
                { id: "about", target: "about", label: "About" },
                { id: "faq", target: "faq", label: "FAQ" },
                { id: "contact", target: "contact", label: "Contact" },
              ].map((n) => (
                <li key={n.id}>
                  <a
                    href={`#${n.target}`}
                    data-testid={`footer-link-${n.id}`}
                    className="hover:text-gold transition-colors"
                  >
                    {n.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-xs uppercase tracking-[0.22em] text-cream/55 mb-4">
              Contact
            </div>
            <ul className="space-y-2.5 text-sm">
              <li>info@dsobookssolutions.com</li>
              <li>(416) 833-9464</li>
              <li>Ontario, Canada · Serving nationwide</li>
            </ul>
          </div>
        </div>

        <div className="pt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-cream/55">
          <div>© {year} DSO Books Solutions Inc. All rights reserved.</div>
          <div className="flex gap-6">
            <span>CRA-compliant workflows</span>
            <span className="hidden sm:inline">·</span>
            <span>QuickBooks &amp; Xero Certified</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
